import { render, staticRenderFns } from "./managementSystem.vue?vue&type=template&id=49fb10dd&scoped=true"
import script from "./managementSystem.vue?vue&type=script&lang=js"
export * from "./managementSystem.vue?vue&type=script&lang=js"
import style0 from "./managementSystem.vue?vue&type=style&index=0&id=49fb10dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb10dd",
  null
  
)

export default component.exports